var map = {
	"./locale-provider/ar_EG.ts": 2434,
	"./locale-provider/bg_BG.ts": 5591,
	"./locale-provider/ca_ES.ts": 3771,
	"./locale-provider/cs_CZ.ts": 9145,
	"./locale-provider/da_DK.ts": 1482,
	"./locale-provider/de_DE.ts": 5362,
	"./locale-provider/el_GR.ts": 5278,
	"./locale-provider/en_GB.ts": 1559,
	"./locale-provider/en_US.ts": 3940,
	"./locale-provider/es_ES.ts": 2841,
	"./locale-provider/et_EE.ts": 6887,
	"./locale-provider/fa_IR.ts": 3674,
	"./locale-provider/fi_FI.ts": 7174,
	"./locale-provider/fr_BE.ts": 7231,
	"./locale-provider/fr_FR.ts": 9570,
	"./locale-provider/ga_IE.ts": 1028,
	"./locale-provider/he_IL.ts": 9337,
	"./locale-provider/hi_IN.ts": 7767,
	"./locale-provider/hr_HR.ts": 8013,
	"./locale-provider/hu_HU.ts": 4382,
	"./locale-provider/hy_AM.ts": 7601,
	"./locale-provider/id_ID.ts": 7455,
	"./locale-provider/is_IS.ts": 3051,
	"./locale-provider/it_IT.ts": 8290,
	"./locale-provider/ja_JP.ts": 4948,
	"./locale-provider/kn_IN.ts": 2205,
	"./locale-provider/ko_KR.ts": 8931,
	"./locale-provider/ku_IQ.ts": 8177,
	"./locale-provider/lv_LV.ts": 3317,
	"./locale-provider/mk_MK.ts": 556,
	"./locale-provider/mn_MN.ts": 6038,
	"./locale-provider/ms_MY.ts": 7262,
	"./locale-provider/nb_NO.ts": 2847,
	"./locale-provider/ne_NP.ts": 4668,
	"./locale-provider/nl_BE.ts": 992,
	"./locale-provider/nl_NL.ts": 5331,
	"./locale-provider/pl_PL.ts": 6674,
	"./locale-provider/pt_BR.ts": 4034,
	"./locale-provider/pt_PT.ts": 3929,
	"./locale-provider/ro_RO.ts": 9589,
	"./locale-provider/ru_RU.ts": 8031,
	"./locale-provider/sk_SK.ts": 2282,
	"./locale-provider/sl_SI.ts": 2644,
	"./locale-provider/sr_RS.ts": 7523,
	"./locale-provider/sv_SE.ts": 8033,
	"./locale-provider/ta_IN.ts": 8558,
	"./locale-provider/th_TH.ts": 3173,
	"./locale-provider/tr_TR.ts": 1072,
	"./locale-provider/uk_UA.ts": 788,
	"./locale-provider/vi_VN.ts": 5546,
	"./locale-provider/zh_CN.ts": 2715,
	"./locale-provider/zh_TW.ts": 8173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7302;